import styled from 'styled-components'
import { Text } from 'sutra/components/Text/Text'
import { textSizeStyles } from 'sutra/components/Text/text-styles'
import { brand } from 'sutra/tokens/colors'
import { typography } from 'sutra/tokens/typography'

// styled(Text) drops `$size` and swallows `as`, so the size is restated here
// and callers pass `forwardedAs`.
export const ModalTitle = styled(Text)`
  ${textSizeStyles.lg}
  color: ${brand.stillNight[800]};
  font-weight: ${typography.weights.semibold};
`
